module.exports = __webpack_public_path__ + "img/0S6A9305.837879f9.jpg";